import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function chart(): ComponentStyle {
  return {
    componentName: 'chart',
    baseStyle: {}
  };
}
